import { render } from "./settingMenu.vue?vue&type=template&id=99d97460"
import script from "./settingMenu.vue?vue&type=script&lang=js"
export * from "./settingMenu.vue?vue&type=script&lang=js"

import "./settingMenu.vue?vue&type=style&index=0&id=99d97460&lang=less"
script.render = render

export default script